__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ufggentportalreact";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@asyarb/use-resize-observer", "2.0.2", () => (() => (__webpack_require__(211))), 1);
			register("@fortawesome/fontawesome-svg-core", "6.7.1", () => (() => (__webpack_require__(63710))), 1);
			register("@fortawesome/free-solid-svg-icons", "5.15.4", () => (() => (__webpack_require__(12639))), 1);
			register("@fortawesome/pro-light-svg-icons", "5.15.4", () => (() => (__webpack_require__(30651))), 1);
			register("@fortawesome/pro-regular-svg-icons", "5.15.4", () => (() => (__webpack_require__(13811))), 1);
			register("@fortawesome/pro-solid-svg-icons", "5.15.4", () => (() => (__webpack_require__(89142))), 1);
			register("@fortawesome/react-fontawesome", "0.1.19", () => (() => (__webpack_require__(86579))), 1);
			register("@fullstory/browser", "1.7.1", () => (() => (__webpack_require__(38905))), 1);
			register("@reduxjs/toolkit", "2.5.0", () => (() => (__webpack_require__(59277))), 1);
			register("@ufginsurance/sso-oidc-client-react", "1.1.9", () => (() => (__webpack_require__(51608))), 1);
			register("@ufginsurance/ui-kit", "3.1.19", () => (() => (__webpack_require__(56397))), 1);
			register("@ungap/structured-clone", "1.2.1", () => (() => (__webpack_require__(30500))), 1);
			register("axios", "1.8.3", () => (() => (__webpack_require__(30182))), 1);
			register("buffer", "6.0.3", () => (() => (__webpack_require__(26382))), 1);
			register("classnames", "2.5.1", () => (() => (__webpack_require__(98139))), 1);
			register("google-map-react", "2.2.1", () => (() => (__webpack_require__(88705))), 1);
			register("launchdarkly-js-client-sdk", "2.24.2", () => (() => (__webpack_require__(85097))), 1);
			register("launchdarkly-react-client-sdk", "2.29.4", () => (() => (__webpack_require__(99639))), 1);
			register("moment", "2.30.1", () => (() => (__webpack_require__(86178))), 1);
			register("oidc-client", "1.11.5", () => (() => (__webpack_require__(66958))), 1);
			register("parse-address", "1.1.2", () => (() => (__webpack_require__(91714))), 1);
			register("prop-types", "15.8.1", () => (() => (__webpack_require__(65173))), 1);
			register("query-string", "5.1.1", () => (() => (__webpack_require__(9370))), 1);
			register("ramda", "0.26.1", () => (() => (__webpack_require__(84739))), 1);
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(97950))), 1);
			register("react-ga", "3.3.1", () => (() => (__webpack_require__(62893))), 1);
			register("react-indexed-db-hook", "1.0.14", () => (() => (__webpack_require__(85395))), 1);
			register("react-localization", "1.0.19", () => (() => (__webpack_require__(55814))), 1);
			register("react-redux", "9.2.0", () => (() => (__webpack_require__(83003))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(62582))), 1);
			register("react-router", "5.3.4", () => (() => (__webpack_require__(91688))), 1);
			register("react-toastify", "9.1.3", () => (() => (__webpack_require__(42145))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(65043))), 1);
			register("redux-oidc", "3.1.7", () => (() => (__webpack_require__(41817))), 1);
			register("redux", "5.0.1", () => (() => (__webpack_require__(23923))), 1);
			register("sanitize-html", "2.13.1", () => (() => (__webpack_require__(12151))), 1);
			register("uuid", "10.0.0", () => (() => (__webpack_require__(11584))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};